import getContext from "../context.js";
import { isUserLoggedIn } from "../utils/loggedInControl.js";

import { retrieveJsonRequest } from "./utils";

const LOGGED_IN_PREFIX = "core";
const LOGGED_OUT_PREFIX = "res";
const DATA_ENDPOINT = "load_more_component/data.js";

function makeParams(componentId, lazyDeps, pageNumber, excludePostIds, lastPostId) {
    const context = getContext();

    const searchParams = new URLSearchParams(context.pathParams);
    searchParams.set("formats", "html");
    searchParams.set("pn_strategy", "");
    searchParams.set("site_id", context.settings.site.id);
    searchParams.set("resource_id", context.settings.resourceId);
    searchParams.set("path_params", JSON.stringify(context.settings.pathParams));
    searchParams.set("pn", pageNumber);
    searchParams.set("component_node_id", componentId);
    searchParams.set("lazy_deps", lazyDeps);

    if (excludePostIds) {
        searchParams.set("exclude_post_ids", excludePostIds);
    }

    if (lastPostId) {
        searchParams.set("last_post_id", lastPostId);
    }

    return searchParams;
}

function makeUrl(componentId, lazyDeps, pageNumber, excludePostIds, lastPostId) {
    const params = makeParams(componentId, lazyDeps, pageNumber, excludePostIds, lastPostId);
    const prefix = isUserLoggedIn() ? LOGGED_IN_PREFIX : LOGGED_OUT_PREFIX;

    return `/${prefix}/${DATA_ENDPOINT}?${params.toString()}`;
}

export function loadMoreComponent(componentId, lazyDeps, pageNumber, excludePostIds, lastPostId) {
    const url = makeUrl(componentId, lazyDeps, pageNumber, excludePostIds, lastPostId);
    return retrieveJsonRequest(url);
}
